module.exports = __webpack_public_path__ + "static/img/Ray Fajar Salinggih-close.6d70247.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/closeup/Ray Fajar Salinggih-close.jpg
// module id = +r6O
// module chunks = 1